import React from 'react';
import classNames from 'classnames';
import { omit } from 'lodash';
import withDeviceType, { type WithDeviceType } from '../../hoc/with-device-type';

type Props = WithDeviceType & React.HTMLAttributes<HTMLDivElement>;

const AppWrapper = ({ isDesktop, isMobile, className, ...rest }: Props) => {
  const elementProps = omit(rest, 'dispatch');
  return (
    <div
      className={classNames(className, {
        'is-mobile': isMobile,
        'app-mobile': isMobile,
        'is-desktop': isDesktop,
        'app-desktop': isDesktop,
      })}
      {...elementProps}
    />
  );
};

export default withDeviceType(AppWrapper);
